import { ISearchLoadingFailed } from '../../../actions/search/loadSearch'
import { ISearchStore } from '../index'

export default function(
  state: ISearchStore,
  action: ISearchLoadingFailed,
): ISearchStore {
  return {
    ...state,
    errMessage: action.message,
    isLoading: false,
    isReady: false,
  }
}
